import React, {cloneElement, useEffect, useState} from 'react';
import {Route, Switch, useHistory, useRouteMatch, Link} from "react-router-dom";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {DELETE_USERS, GET_USERS} from "../../database/queries/userQueries";
import {notify} from "../../utils/notify";
import useLayoutStore from "../../layoutStore";
import {makeStyles} from "@material-ui/core/styles";
import Moment from "react-moment";
import CalendarStrings from "../../constants/calendarStrings";
import PageBar from "../Common/PageBar";
import {SizeMe} from "react-sizeme";
import MaterialTable from "material-table";
import tableIcons from "../../constants/tableIcons";

// const inIFrame = (window.parent.window !== window);

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        marginTop: 20,
    },
}));

const UserList = props => {
    const classes = useStyles();
    const [searchStr, setSearchStr] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedObj, setSelectedObj] = useState({});
    const [globalLayoutState] = useLayoutStore();
    const [users, setUsers] = useState([]);
    let {url} = useRouteMatch();
    const history = useHistory();

    const columns = [
        {
            title: 'Name',
            width: '30%',
            render: r => {
                return (
                    <Link to={`${url}/${r.userId}`}>
                        {r.displayName}
                    </Link>
                );
            },
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Email',
            width: '30%',
            render: r => {
                return (
                    <Link to={`${url}/${r.userId}`}>
                        {r.email}
                    </Link>
                );
            },
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Created',
            width: '20%',
            render: r => <Moment calendar={CalendarStrings}>{r.createdAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
        {
            title: 'Last Updated',
            width: '20%',
            render: r => <Moment calendar={CalendarStrings}>{r.updatedAt}</Moment>,
            headerStyle: {padding: 6},
            cellStyle: {padding: 6}
        },
    ];

    const {loading: getUsersLoading, error: getUsersError, data: getUsersData, refetch: getUsersRefetch} = useQuery(GET_USERS, {
        variables: {
            searchStr: searchStr,
            // limit: 10,
            // offset: 0,
            orderList: ['updatedAt DESC']
        },
    });

    const [deleteUsers, {error: deleteUsersError}] = useMutation(DELETE_USERS);

    const handleSearch = (s) => {
        setSearchStr(s);
        getUsersRefetch();
    };

    const handleRefresh = () => {
        getUsersRefetch();
    };

    const handleDelete = () => {
        const selectedIds = selectedRows.map(row => row.userId);
        deleteUsers({
            variables: {deleteUserIds: selectedIds}
        }).then(deleteUsersResult => {
            if (deleteUsersResult.data.deleteUsers.returnCode === 0) {
                notify('deleteUsers', 'info', deleteUsersResult.data.deleteUsers.message);
            } else {
                notify('deleteUsers', 'error', deleteUsersResult.data.deleteUsers.message);
            }
            getUsersRefetch();
        }).catch(e => {
            notify('deleteUsers', 'error', e.message);
            getUsersRefetch();
        })
    };

    const handleImport = () => {
        console.log('import');
    };

    const handleExport = () => {
        console.log('export');
    };

    useEffect(() => {
        if (getUsersData && getUsersData.users) {
            setSelectedRows([]);
            setSelectedObj({});
            setUsers(getUsersData.users);
        }
    }, [getUsersData]);

    useEffect(() => {
        getUsersRefetch();
    }, [getUsersRefetch]);

    useEffect(() => {
        if (deleteUsersError) notify('deleteUserError', 'error', deleteUsersError.message);
        if (getUsersError) notify('getUsersError', 'error', getUsersError.message);
    }, [deleteUsersError, getUsersError]);

    return (
        <Switch>
            <Route exact path={`${url}`}>
                <PageBar
                    title={`Users (${selectedRows.length}/${users.length})`}
                    handleSearch={handleSearch}
                    handleRefresh={handleRefresh}
                    handleAdd={() => {
                        console.log('## SVR userList ## changing history', `${url}/new`);
                        history.push(`${url}/new`);
                    }}
                    handleEdit={() => {
                        console.log('## SVR userList ## changing history', `${url}/${selectedObj.taskId}`);
                        history.push(`${url}/${selectedObj.taskId}`);
                    }}
                    editDisabled={selectedRows.length !== 1}
                    tagDisabled={selectedRows.length === 0}
                    handleDelete={handleDelete}
                    deleteDisabled={selectedRows.length === 0}
                    handleImport={handleImport}
                    handleExport={handleExport}
                    exportDisabled={selectedRows.length === 0}
                    showLoading={getUsersLoading}
                >
                </PageBar>
                <div className={classes.root}>
                    {users && (
                        <SizeMe>
                            {({size}) => {
                                let height = size.height;
                                if (!height) height = window.innerHeight;

                                const tableOptions = {
                                    actionsColumnIndex: -1,
                                    header: true,
                                    maxBodyHeight: height - (globalLayoutState.tabBarHeight + 50),
                                    padding: 'dense',
                                    paging: false,
                                    selection: true,
                                    selectionProps: r => ({
                                        name: r.displayName.replace(/\s+/g, '-').toLowerCase() === '___test' ? 'checkTest' : ''
                                    }),
                                    toolbar: false,
                                };

                                return (<MaterialTable
                                    columns={columns}
                                    data={users}
                                    icons={tableIcons}
                                    options={tableOptions}
                                    title='Users'
                                    onSearchChange={(str) => {
                                        setSearchStr(str);
                                    }}
                                    onSelectionChange={(rows) => {
                                        setSelectedRows(rows);
                                        if (rows.length === 1) {
                                            setSelectedObj(rows[0])
                                        } else {
                                            setSelectedObj({})
                                        }
                                    }}
                                />);
                            }}
                        </SizeMe>
                    )}
                </div>
            </Route>}
            <Route path={`${url}/:editId`}>
                {cloneElement(props.parent.routes.edit.component, {
                    ...props,
                    parentRefresh: () => {
                        getUsersRefetch()
                    },
                    editType: 'user',
                    parent: props.parent.routes.edit
                })}
            </Route>
        </Switch>
    );
};

export default UserList;
